import { Link, useTitle } from "../lib/router";

export function NotFound() {
  useTitle("Not found");
  return (
    <main id="main" className="page">
      <h1>Off the beat</h1>
      <p>There's nothing at this address.</p>
      <Link className="btn" href="/">
        Back to the song
      </Link>
    </main>
  );
}
